import {
  useState,
  useEffect,
  createContext,
  useMemo,
  useCallback,
} from "react";
import axios from "axios";
import { ROOT_SERVER, MATERIAL_URL, NIKESTORE } from "../utilities/Static";
import SortFunction from "../utilities/SortFunction";

import { useQuery } from "@tanstack/react-query";

export const MaterialContext = createContext();

const MaterialContextProvider = ({ children }) => {
  const [nikeData, setNikeData] = useState([]);
  const [search, setSearch] = useState("");
  ///Filters
  const [isFilter, setIsFilter] = useState(false);
  const [priceRange, setPriceRange] = useState([{ min: 1.8, max: 2.5 }]);
  const [status, setStatus] = useState("commercial");
  const [orderBy, setOrderBy] = useState("modified");

  const { isError, isSuccess, data, refetch } = useQuery({
    queryKey: ["materials"],
    queryFn: () => axios.get(MATERIAL_URL),
  });

  const allMaterials = useMemo(() => {
    return Array.isArray(data?.data) ? data.data : [];
  }, [data]);

  const materialsLoaded = !isError && isSuccess;

  const materials = useMemo(() => {
    return SortFunction(search, allMaterials, orderBy, priceRange, status);
  }, [search, allMaterials, orderBy, priceRange, status]);

  const materialById = useMemo(() => {
    const map = new Map();
    allMaterials.forEach((material) => {
      if (material?.id != null) {
        map.set(material.id, material);
      }
    });
    return map;
  }, [allMaterials]);

  const nikeDataBySlug = useMemo(() => {
    const map = new Map();
    nikeData.forEach((item) => {
      if (!item?.slug) {
        return;
      }

      const existing = map.get(item.slug);
      if (existing) {
        existing.push(item);
      } else {
        map.set(item.slug, [item]);
      }
    });
    return map;
  }, [nikeData]);

  useEffect(() => {
    axios.get(NIKESTORE).then((response) => {
      setNikeData(response.data);
    });
  }, []);

  const changeStatus = useCallback((value) => {
    setStatus(value);
  }, []);

  const changeSearch = useCallback((value) => {
    setSearch(value);
  }, []);

  const changeOrderBy = useCallback((value) => {
    setOrderBy(value);
  }, []);

  const changePriceRange = useCallback((value) => {
    setPriceRange(value);
  }, []);

  const changeIsFilter = useCallback((value) => {
    setIsFilter(value);
  }, []);

  const value = useMemo(
    () => ({
      allMaterials,
      materialById,
      materialsLoaded,
      nikeData,
      nikeDataBySlug,
      ROOT_SERVER,
      materials,
      status,
      refetch,
      changeStatus,
      search,
      changeSearch,
      orderBy,
      changeOrderBy,
      priceRange,
      changePriceRange,
      isFilter,
      changeIsFilter,
    }),
    [
      allMaterials,
      materialById,
      materialsLoaded,
      nikeData,
      nikeDataBySlug,
      materials,
      status,
      refetch,
      changeStatus,
      search,
      changeSearch,
      orderBy,
      changeOrderBy,
      priceRange,
      changePriceRange,
      isFilter,
      changeIsFilter,
    ],
  );

  return (
    <MaterialContext.Provider value={value}>
      {children}
    </MaterialContext.Provider>
  );
};

export default MaterialContextProvider;
